var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 5a5 5 0 0 1 10 0v2A5 5 0 0 1 5 7V5zM0 16.68A19.9 19.9 0 0 1 10 14c3.64 0 7.06.97 10 2.68V20H0v-3.32z"}));
}

User.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = User;

User.default = User;
